import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useHistory, useParams } from 'react-router-dom';
import { TabContext, TabPanel } from '@material-ui/lab';

import {
  LinearProgress,
  Grid,
  Card,
  CardActions,
  Button,
  Tabs,
  Tab,
  Box
} from '@material-ui/core';
import {
  getStoreProductsApi,
  getQuoteProProductsApi,
  getAllTasksFromQueueApi,
  getQuoteProGroupsAttributeApi,
  getAllBrandsApi
} from 'api';
import { imgBaseUrl } from 'configs';
import useProducts from 'hooks/useProducts';
import { Breadcrumb } from 'components';
import logo from 'components/Logo/logo-dermpro.svg';
import listingsImage from 'components/Pages/listings-img.svg';
import StoreProductsQueue from 'pages/catalog/storeProductsQueue';
import QuoteProductsList from './QuoteProductsList';
import CopyStoreListings from './CopyStoreListings';
import useStyles from './styles';


const QuoteListings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const {selectedTab = 'active'} = useParams<{selectedTab?: string}>();

  const [catalog, setCatalog] = useState([]);

  const { stores = [] } = useSelector((state: IReduxState) => state.user.profile);
  const { allBrands, loadingAllBrands } = useSelector((state: IReduxState) => state.brands);
  const {profile} = useSelector((state: IReduxState) => state.user);
  const {quoteGroupsAttributeData} = useSelector((state: IReduxState) => state.quote);

  const mediaStoreUrl = `${stores[0]?.apiUrl}/media/catalog/product` || imgBaseUrl;
  const userStore = stores?.[0];
  const permissions = profile?.config?.permissions || {};


  const {
    allStoreProducts,
    allQuoteProducts,
    activeQuoteProducts,
    disabledQuoteProducts,
    quoteProductsLoading,
    queueTasks: queueQuoteTasks,
    queueTasksSkus: queueQuoteTasksSkus
  } = useProducts(userStore.quoteProStoreCode);

  useEffect(() => {
    getAllTasksFromQueueApi({dispatch, storeViewCode: userStore.quoteProStoreCode});

    if (!allBrands.length) {
      getAllBrandsApi({dispatch});
    }

    if (!allQuoteProducts.length) {
      getQuoteProProductsApi({dispatch});
      getStoreProductsApi({dispatch});
    }

    // TODO: this is temporary solution
    // remove this condition after create quote refactoring
    // create quote page should use products from another state in redux
    if (!disabledQuoteProducts.length) {
      getQuoteProProductsApi({dispatch});
    }

    if (!quoteGroupsAttributeData.options?.length) {
      getQuoteProGroupsAttributeApi({dispatch});
    }
  }, []);

  // useEffect(() => {
  //   getStoreProductExportApi({dispatch});
  // }, [allQuoteProducts.length]);

  useEffect(() => {
    if (selectedTab === 'queue' && !queueQuoteTasks?.length) {
      history.push('draft');
    }
  }, [queueQuoteTasks?.length]);

  useEffect(() => {
    if (allBrands?.length && allQuoteProducts?.length) {
      setCatalog([...allQuoteProducts.map((product) => {
        const productBrand = product?.custom_attributes?.find((attr) => attr.attribute_code === 'brand')?.value;
        const productImagePath = product?.custom_attributes?.find((attr) => attr.attribute_code === 'image')?.value;

        return {
          ...product,
          image: productImagePath ? `${mediaStoreUrl}${productImagePath}` : logo,
          price: product?.price?.toFixed(2) || '0',
          brand: allBrands?.find((b) => b.option_id === productBrand)?.value || '',
          status: product?.status === 1 ? 'Enabled' : 'Disabled',
        };
      })]);
    } else {
      setCatalog([]);
    }
  }, [allQuoteProducts.length, allBrands]);

  const loading = quoteProductsLoading || loadingAllBrands;

  return (
    <>
      <div className="flex-grow h-full min-h-full-screen scroll-y pb-25">
        <div className="mb-sm-30">
          <Breadcrumb
            routeSegments={[
              { name: 'Quote Listings' }
            ]}
          />
        </div>
        {!loading && catalog?.length > 0 &&
          <Grid container className="flex px-10 pt-0 pb-4" justifyContent="flex-end">
            <div>
              {permissions?.listingsLibrary &&
              <Link to="/browse-brand/quote">
                <Button
                  variant="contained"
                  color="primary"
                  className="mr-2 uppercase"
                  title="Click here to add a standard/common SKU"
                >
                  Add product from Library
                </Button>
              </Link>
              }
              {!!allStoreProducts?.length &&
              <CopyStoreListings
                allStoreProducts={allStoreProducts}
                quoteStoreId={userStore.quoteProStoreId}
                quoteStoreViewCode={userStore.quoteProStoreCode}
                classes="uppercase mr-2"
              />
              }
              {permissions?.listingsAddNew &&
                <Button
                  variant="outlined"
                  color="primary"
                  className={classes.requestSkuButton}
                  title="Click here to add a custom/specialty SKU"
                  onClick={() => {
                    history.push({
                      pathname: '/request-sku',
                      state: { from: '/quoting/listings' }
                    });
                  }}
                >
                  Request Custom Listing
                </Button>
              }
            </div>
          </Grid>}
        <div className="mx-10">
          {loading && <LinearProgress className="mt-10" />}
          {!loading && (!catalog?.length && !allQuoteProducts.length) &&
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              className="mt-20"
            >
              <div className="flex-grow flex-column relative scroll-y justify-center items-center">
                <img src={listingsImage} alt="under reconstruction" width="258" />
              </div>
              <h2 className="font-bold py-6 text-center text-deep-gray">Add and manage your quote listings</h2>
              <p className="py-6 text-center">This is where you&apos;ll add listings to your quoting and configure them.</p>
              <CardActions>
                {permissions?.listingsLibrary &&
                  <Link to="/browse-brand/quote">
                    <Button
                      variant="contained"
                      color="primary"
                      className="uppercase"
                      title="Click here to add a standard/common SKU"
                    >
                      Add product from Library
                    </Button>
                  </Link>
                }
                {!!allStoreProducts?.length &&
                <CopyStoreListings
                  allStoreProducts={allStoreProducts}
                  quoteStoreId={userStore.quoteProStoreId}
                  quoteStoreViewCode={userStore.quoteProStoreCode}
                  classes="uppercase mr-2"
                />
                }
                {permissions?.listingsAddNew &&
                  <Link to="/request-sku">
                    <Button
                      variant="outlined"
                      className="uppercase"
                      title="Click here to add a custom/specialty SKU"
                    >
                      Request Custom Listing
                    </Button>
                  </Link>
                }
              </CardActions>
            </Grid>
          }
          {!loading && (catalog?.length > 0 || allQuoteProducts.length > 0) &&
          <Card>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabContext value={selectedTab}>
                <Tabs
                  value={selectedTab}
                  onChange={(event, newValue) => history.push(newValue)}
                  className={classes.rootTabs}
                >
                  <Tab
                    className={classes.tabsTitles}
                    label={`Active (${activeQuoteProducts?.length || 0})`}
                    value="active"
                    component={Link}
                    to="/quoting/listings/active"
                  />
                  <Tab
                    className={classes.tabsTitles}
                    label={`Disabled (${disabledQuoteProducts?.length || 0})`}
                    value="draft"
                    component={Link}
                    to="/quoting/listings/draft"
                  />
                  {!!queueQuoteTasks?.length &&
                  <Tab
                    className={classes.tabsTitles}
                    label={`Queue (${queueQuoteTasks?.length || 0})`}
                    value="queue"
                    component={Link}
                    to="/quoting/listings/queue"
                  />}
                </Tabs>
                <TabPanel className="p-0" value="active">
                  <QuoteProductsList
                    productsList={activeQuoteProducts}
                    queueTasks={queueQuoteTasks}
                    queueTasksSkus={queueQuoteTasksSkus}
                    tabValue="active"
                  />
                </TabPanel>
                <TabPanel className="p-0" value="draft">
                  <QuoteProductsList
                    productsList={disabledQuoteProducts}
                    queueTasks={queueQuoteTasks}
                    queueTasksSkus={queueQuoteTasksSkus}
                    tabValue="disabled"
                  />
                </TabPanel>
                <TabPanel className="p-0" value="queue">
                  <StoreProductsQueue queueTasks={queueQuoteTasks} />
                </TabPanel>
              </TabContext>
            </Box>
          </Card>
          }
        </div>
        {/* <BackdropCircular loading={deletingProduct} /> */}
      </div>
    </>
  );
};

export default QuoteListings;
